import React from 'react';
import { wrapUrlInImgOrDefault, CHAINS_DICT } from 'utils';

import './index.css';

// 堆叠小图标
export const TokensIcons = React.memo(
  (props: {
    icons: (string | undefined)[] | (string | undefined);
    nftIcons?: (string | undefined)[];
    isMobile?: boolean;
    width?: number;
    margin?: number;
    chain?: string;
  }) => {
    const { icons: _icons, isMobile, width: defaultWidth = 20, chain, nftIcons } = props;
    const margin = props.margin ?? 6;
    let icons = Array.isArray(_icons) ? _icons : [_icons];
    const width = (defaultWidth ? defaultWidth / 2 : 10) + (isMobile ? 0 : margin / 2);
    const imgs = [
      ...(nftIcons ?? []).map(n => wrapUrlInImgOrDefault(n, defaultWidth, { borderRadius: 4 })),
      ...icons.map(v => wrapUrlInImgOrDefault(v, defaultWidth)),
    ];
    const containerWidth = 2 * width + (imgs.length - 1) * width;
    return (
      <div style={{ width: containerWidth }} className="tokenIcons">
        {imgs.map((v, i) => (
          <div style={{ left: i * -width + 'px' }} key={i}>
            {v}
          </div>
        ))}
        {chain && chain !== 'eth' && (
          <img
            style={{ right: margin / 2 + 2 }}
            src={CHAINS_DICT[chain]?.logo}
            alt=""
            className="chain"
          />
        )}
      </div>
    );
  },
);

export default TokensIcons;
